// Profile Page
import React from 'react';
import { NextSeo } from 'next-seo';
import { NextPageWithLayout } from 'types/page';
import { getAppLayout } from 'components/containers/AppLayout';
import ProfileView from 'components/views/Profile';
import ProfileStyles from 'components/views/Profile/Profile.module.sass';
import ROUTES from 'config/routes';
import AuthPageProtection from 'components/containers/AuthProtection';

/**
 * User Profile: Page description
 * @return {NextPageWithLayout}
 */
const PageTitle = 'Profile';
const Profile: NextPageWithLayout = () => {
  return (
    <>
      <NextSeo title={PageTitle} />
      <AuthPageProtection options={{ permissions: ROUTES.Profile.permissions }}>
        <ProfileView />
      </AuthPageProtection>
    </>
  );
};

Profile.getLayout = getAppLayout({
  title: PageTitle,
  headerClassName: ProfileStyles.header,
});

export default Profile;
